import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Logg ut")

import { AuxButton } from '@ambita/design-system';
import { useMsal } from '@/composition-api/useMsal';
import WelcomeName from '../SignIn/WelcomeName.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SignOutButton',
  setup(__props) {

const { instance } = useMsal();
/*const logoutPopup = () => {
  instance.logoutPopup({
    mainWindowRedirectUri: '/',
  });
};*/
const logoutRedirect = () => {
  instance.logoutRedirect();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(WelcomeName),
    _createVNode(_unref(AuxButton), {
      primary: false,
      class: "btn",
      onClick: logoutRedirect
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    })
  ]))
}
}

})